import paymentHelpers from '@/library/payments/paymentHelpers'
import mobileBridge from '@/library/mobileBridge'

function handleIFrame (params, viewModel) {
  if (params && params.data && params.data.data === 'closePNMIFrame') {
    /* if there is a viewModel reference, an iFrame is opened from this component
    if not, an iFrame is opened from pushDebit component, so we will broadcast an event
    and catch that event in the pushDebit component */
    if (viewModel) {
      viewModel.closePNMIFrame()
    }
    window.postMessage({
      data: 'closePNMPushDebitIFrame',
      URIqueryString: params && params.data && params.data.URIqueryString
    }, '*')
  }
  if (params && params.data === 'navigate2PaymentCompletedPage') {
    viewModel.$router.push('pnm-payment-completed')
  }
}

function checkIsRedirectedFromInAppBrowserAndIntercept () {
  let url = window.location.href
  const IsRedirectedFromPNM = url.includes('pnm-redirect-mobile')
  const isWebView = !window.ctsautoconf.MOBILE_LS
  if (IsRedirectedFromPNM && isWebView) {
    url = url.replace(/\/pnm-redirect-mobile-[A-Za-z]+/, '')
    const origin = window.location.origin
    const formatedOrigin = paymentHelpers.removeTrailingSlash(origin)
    url = url.replaceAll(formatedOrigin, 'igt-nuvei-link:/')
    document.location = url
  }
}

function openInAppBrowser (url, paymentType) {
  const origin = window.ctsautoconf.WEB_SERVER_HOSTNAME || ''
  const formatedOrigin = `${paymentHelpers.removeTrailingSlash(origin)}/pnm-redirect-mobile-${paymentType}`
  const returnUrl = `${formatedOrigin}${window.location.pathname}`
  let decoratedUrl = `${url}?return_url=${returnUrl}&pay_url=${formatedOrigin}/account/pnm-payment-completed&no_pay_url=${formatedOrigin}/account/pnm-payment-not-completed`
  if (paymentType === 'PNMVenmo') {
    mobileBridge.bridgeSendRequest('openPopUpBridge', decoratedUrl)
    return
  }
  mobileBridge.bridgeSendRequest('openIgtPay', decoratedUrl)
}

export default {
  handleIFrame,
  checkIsRedirectedFromInAppBrowserAndIntercept,
  openInAppBrowser
}



// WEBPACK FOOTER //
// ./src/library/payments/pnmManager.js